import * as React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import XlContainer from 'components/XlContainer'
import StandardLayout from 'components/StandardLayout'
import { RenderOnDesktop, RenderOnMobile } from 'components/DeviceUtils'
import CustomerBanner from 'components/CustomerBanner'
import GreyGradient from 'components/GreyGradient'
import LogisticsAnimation from 'views/Customers/Sections/Logistics/LogisticsAnimation'
import LogisticsTabSection from 'views/Customers/Sections/Logistics/LogisticsTabSection'
import useIsMobile from 'hooks/useIsMobile'

const stackSpacing = {
    xs: 10,
    sm: 15,
    md: 15,
    lg: 15,
    xl: 15,
}

const Logistics = () => {
    const isMobile = useIsMobile()
    return (
        <>
            <XlContainer>
                <Stack
                    spacing={stackSpacing}
                    sx={{
                        pt: {
                            xs: 9,
                            sm: 15,
                            md: 15,
                            lg: 15,
                            xl: 15,
                        },
                    }}
                >
                    <GreyGradient radial>
                        <StandardLayout sx={{ pb: 3 }}>
                            <RenderOnMobile>
                                <Typography
                                    variant={`h3`}
                                    component="div"
                                    sx={{ textAlign: `left` }}
                                >
                                    Winning over shippers looking for sustainable logistics
                                </Typography>
                            </RenderOnMobile>
                            <RenderOnDesktop>
                                <Typography
                                    variant={`h3`}
                                    component="div"
                                    sx={{ textAlign: `center` }}
                                >
                                    Winning over shippers looking
                                </Typography>
                                <Typography
                                    variant={`h3`}
                                    component="div"
                                    sx={{ textAlign: `center` }}
                                >
                                    for sustainable logistics
                                </Typography>
                            </RenderOnDesktop>
                        </StandardLayout>
                    </GreyGradient>
                </Stack>
            </XlContainer>
            <XlContainer>
                <Stack
                    spacing={stackSpacing}
                    sx={{
                        pt: {
                            xs: 9,
                            sm: 15,
                            md: 15,
                            lg: 15,
                            xl: 15,
                        },
                    }}
                >
                    <GreyGradient hide={!isMobile}>
                        <StandardLayout sx={{ py: isMobile ? 0 : 10 }}>
                            <LogisticsTabSection />
                        </StandardLayout>
                    </GreyGradient>
                    <StandardLayout>
                        <CustomerBanner
                            image={
                                <StaticImage
                                    placeholder={'dominantColor'}
                                    width={360}
                                    height={440}
                                    layout={'fixed'}
                                    src={'../../../../images/customerBanners/forto1-desktop.png'}
                                    alt={'building'}
                                    style={{ borderRadius: '32px' }}
                                />
                            }
                            mobileImage={
                                <StaticImage
                                    placeholder={'dominantColor'}
                                    width={360}
                                    height={440}
                                    layout={'fixed'}
                                    src={'../../../../images/customerBanners/forto1-mobile.png'}
                                    alt={'building'}
                                    style={{ borderRadius: '32px' }}
                                />
                            }
                            customerLogo={'https://assets.lune.co/lune-co/tabs-logos/forto.png'}
                            text="Over 70% of Forto’s customers compensate for their transport emissions"
                        />
                    </StandardLayout>
                </Stack>
            </XlContainer>
            <XlContainer
                sx={{
                    maxWidth: '2120px !important',
                    py: stackSpacing,
                }}
            >
                <LogisticsAnimation />
            </XlContainer>
        </>
    )
}

export default Logistics
